import React from 'react'
import {animateScroll as scroll} from "react-scroll"
import {FaFacebook,FaLinkedin,FaTwitter,FaGithub,FaCubes} from 'react-icons/fa'

import {
    FooterContainer,
    FooterLinksContainer,
    FooterWrap,
    FooterLink,
    FooterLinkItems,
    FooterLinksWrapper,
    FooterLinkTitle,
    FooterLinkHead,
    SocialMedia,
    SocialMediaWrap,
    SocialLogo,
    SocialIcons,
    SocialIconLink,
} from "./FooterElements"

function Footer() {

    const toggleHome = () =>{
        scroll.scrollToTop();
    }

    return (
        <>
        <FooterContainer>
            <FooterWrap>
                <FooterLinksContainer>
                    <FooterLinksWrapper>
                        <FooterLinkItems>
                            <FooterLinkHead>Innovative and technically-astute software developer well-versed in analyzing user needs and developing software to precisely meet diverse needs.The possibilities are endless!</FooterLinkHead>
                        </FooterLinkItems>
                        <FooterLinkItems>
                        <FooterLinkTitle>Links</FooterLinkTitle>
                            <FooterLink to='about' smooth={true} duration={500} spy={true} exact='true' offset={-80}>About</FooterLink>
                            <FooterLink to='services' smooth={true} duration={500} spy={true} exact='true' offset={-80}>Services</FooterLink>
                            <FooterLink to='portfolio' smooth={true} duration={500} spy={true} exact='true' offset={-80}>Portfolio</FooterLink>
                            <FooterLink to='contact' smooth={true} duration={500} spy={true} exact='true' offset={-80}>Contacts</FooterLink>
                        </FooterLinkItems>
                    </FooterLinksWrapper>

                </FooterLinksContainer>

                <SocialMedia> 
                    <SocialMediaWrap>
                        <SocialLogo to="/" onClick={toggleHome}><FaCubes/>  vuni</SocialLogo>
                        <SocialIcons>
                            <SocialIconLink href="https://https://www.facebook.com/fred.vuni.1" target="_blank" aria-label="Facebook">
                                <FaFacebook/>
                            </SocialIconLink>

                            <SocialIconLink href="https://github.com/FREDVUNI/" target="_blank" aria-label="Git">
                                <FaGithub/>
                            </SocialIconLink>

                            <SocialIconLink href="https://www.linkedin.com/in/fred-vuni-3028a721b/?originalSubdomain=ug" target="_blank" aria-label="LinkedIn">
                                <FaLinkedin/>
                            </SocialIconLink>

                            <SocialIconLink href="https://twitter.com/Fredvuni" target="_blank" aria-label="Twitter">
                                <FaTwitter/>
                            </SocialIconLink>
                        </SocialIcons>
                    </SocialMediaWrap>
                </SocialMedia>
            </FooterWrap>     
        </FooterContainer>   
        </>
    )
}

export default Footer
